import React, { PropsWithChildren } from 'react';
import clsx from 'clsx';

/* eslint-disable no-restricted-imports -- this file is the app's abstraction over react-router. */
import { Link as ReactRouterLink } from 'react-router-dom';

export function Link({
  to,
  id,
  children,
  target,
  className,
  rel,
  replace,
  style,
  'data-testid': dataTestId,
}: PropsWithChildren<{
  to: string;
  id?: string;
  target?: string;
  className?: string;
  rel?: string;
  replace?: boolean;
  style?: React.CSSProperties;
  'data-testid'?: string;
}>) {
  // NOTE: rel="noopener noreferrer" keeps a _blank target from reaching window.opener.
  const _rel = target === '_blank' ? clsx('noopener noreferrer', rel) : rel;

  return (
    <ReactRouterLink
      to={to}
      className={clsx('wk-link', className)}
      target={target}
      rel={_rel}
      style={style}
      data-testid={dataTestId}
      replace={replace}
      id={id}
    >
      {children}
    </ReactRouterLink>
  );
}
